import { defineComponent as _defineComponent } from 'vue'
import {
  AbTitle,
  AbSection,
  AbContainer,
  AbDescription,
  AbSectionLayout,
  AbVideoYoutube,
  type AbVideoYoutubeProps,
} from '../../../ui';
import { Spacing } from '../../../../helpers/shared-props';
import { TextAlign } from '../../../../types';
import { ref } from 'vue-demi';
import { useSectionAnalytics } from '../../../../analytics';

interface Props {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  textAlign?: TextAlign | null;
  items: AbVideoYoutubeProps[];
  spacing?: Spacing | null;
  analytics_placement?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoSectionSimple',
  props: {
    id: null,
    title: null,
    description: null,
    textAlign: null,
    items: null,
    spacing: null,
    analytics_placement: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  textAlign?: TextAlign | null;
  items: AbVideoYoutubeProps[];
  spacing?: Spacing | null;
  analytics_placement?: string | null;
};


const sectionRef = ref<HTMLElement | null>(null);

const { trackSelectItem } = useSectionAnalytics(sectionRef, {
  placement: props.analytics_placement ?? '',
}, {sectionName: 'VideoSectionSimple'});

const handleSectionClick = () => {
  trackSelectItem();
};

return { __sfc: true,props, sectionRef, trackSelectItem, handleSectionClick, AbTitle, AbSection, AbContainer, AbDescription, AbSectionLayout, AbVideoYoutube }
}

})